import React, { useState } from 'react'
import { faGripLines, faArrowUpRightFromSquare, faEye } from "@fortawesome/free-solid-svg-icons";
import "./TransferList.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { camelToStartCase } from '../../utils/utils';
import { widgetItem } from '../../features/homepageConfiguration/HomepageConfiguration';
import { BannerPreview } from '../bannerPreview/BannerPreview';
import { BannerElement } from '../../types';
import { useNavigate } from 'react-router-dom';
interface transferList {
  items?: widgetItem[],
  handleRemove: (items: any) => void
  setItems: React.Dispatch<React.SetStateAction<any>>
}

const TransferList = (props: transferList) => {
  const navigate = useNavigate();
  const { items, handleRemove, setItems } = props;
  const [openBannerPreview, setOpenBannerPreview] = useState(false);
  const [currentBannerElements, setcurrentBannerElements] = useState<BannerElement[]>([]);
  const reorder = (list: any, startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
    userSelect: "none",
    margin: 0,
    ...draggableStyle
  });

  const getListStyle = (isDraggingOver: boolean) => ({
    background: "#F3FCFB",
    padding: `1rem`,
  });

  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }

    const reorderedItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );

    setItems(reorderedItems);
  };
  const handleEye = (item:widgetItem) => {
    setcurrentBannerElements(item.bannerElements)
    setOpenBannerPreview(true);
  }

  const widgetRedirect = (item:widgetItem) =>{
    switch (item.type){
      case "banner": {
        navigate("/manageBanner")
        return;
      }
      case "basket": {
        navigate("/manageBasket")
        return;
      }
      case "bucket": {
        navigate("/manageBucket")
        return;
      }
    }
  }

  return (
    <div className='transfer_list_container'>
      <BannerPreview openBannerPreview={openBannerPreview} setOpenBannerPreview={setOpenBannerPreview} bannerElements={currentBannerElements}/>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {items?.length ? items?.map((item, index) => (
                <Draggable key={"widget" + item.id} draggableId={"widget" + item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      className="card"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                    >
                      <div className="item_card">
                        <span>
                          <FontAwesomeIcon className='transfer_list_grip_lines_icon' icon={faGripLines} />
                          {camelToStartCase(item.type)} - {camelToStartCase(item.displayName ?? item.name)}
                        </span>
                        <span className='homepage_icon_container'>
                          {item.type === "banner" && <span onClick={() => handleEye(item)}>
                            <FontAwesomeIcon icon={faEye} />
                          </span>}
                          {item.type !== "banner" && <span></span>}
                          {item.type !== "marquee" && 
                              <span><FontAwesomeIcon icon={faArrowUpRightFromSquare} onClick={()=>{widgetRedirect(item)}} /></span>
                          }
                          {item.type === "marquee" && <span></span>}
                          <span className='circle_icon' onClick={() => handleRemove(item)}><span className='hyphen_icon' /></span>
                        </span>
                      </div>
                    </div>
                  )}
                </Draggable>
              )) : <span style={{ color: 'white' }}>Please add an item</span>}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  )
}

export default TransferList